<template>
    <div>
        <div class="dx-field ai-form-number-box-readonly">
            <div class="dx-field-label ai-form-number-box-readonly-label">{{ meta.title }}</div>
            <div :class="fieldValueClass">
                <dx-number-box
                    :value="serverData[meta.fieldNameText]"
                    :read-only="true"
                    :input-attr="{ style: 'text-align: right' }"
                />
            </div>
        </div>
    </div>
</template>
<script setup>
import { DxNumberBox } from 'devextreme-vue';
import { computed } from 'vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {},
    },
    serverData: {
        type: Object,
        default: () => {},
    },
    isModified: {
        type: Boolean,
        default: () => false,
    }
});

const fieldValueClass = computed(() => {
    return {
        'dx-field-value': true,
        'ai-field-modified': props.isModified,
    };
});
</script>
<style lang="scss" scoped></style>

